import script from "./HomeTickerComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeTickerComponent.vue?vue&type=script&lang=ts&setup=true"

import "./HomeTickerComponent.scss?vue&type=style&index=0&id=2b119812&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b119812"]])

export default __exports__